import type { User } from '../../../types/User';

/**
 * Infer a service-area default from the signed-in user.
 *
 * HE no longer asks for service area on the form. We take the first
 * `userServiceAreas` assignment so vendor/PO/rate lookups stay scoped.
 */
export function resolveDefaultServiceAreaId(user: User | null | undefined): number | null {
  const assigned = user?.userServiceAreas ?? [];
  const firstAssignedId = assigned[0]?.serviceAreaId ?? assigned[0]?.serviceArea?.id;
  return firstAssignedId ?? null;
}
